import IssueCard from '../views/IssueCard.vue';
import IssueEapCard from '../views/IssueEapCard.vue';
import Issues from '../views/Issues.vue';
import IssuesEap from '../views/IssuesEap.vue';

export const routes = [
  {
    path: '/tasks/issues/',
    name: 'Issues',
    component: Issues,
  },
  {
    path: '/tasks/issues/:action/:id',
    name: 'IssueCard',
    component: IssueCard,
  },
  {
    path: '/tasks/eap/',
    name: 'IssuesEap',
    component: IssuesEap,
  },
  {
    path: '/tasks/eap/:action/:id',
    name: 'IssueEapCard',
    component: IssueEapCard,
  },
];
